import { trimObject } from "helpers/object";
import { IContactForm } from "store/entities/contact-forms/interfaces";

import { IRawContactForm } from "./interfaces";

export function deserialize(payload: IRawContactForm): IContactForm {
  if (payload.version === 1 && payload.lcGroupIDs.length === 0) {
    return {
      id: payload.ID,
      teamID: payload.teamID,
      name: payload.name,
      licenseID: payload.licenseID,
      livechatGroupIDs: payload.lcGroupIDs.map(String),
      version: 2,
      wordpressContactForm: !!payload.settings.wordpressContactForm,
      updatedAt: payload.updatedAt,
      fields: [
        {
          type: "header",
          value: payload.settings.header || "",
        },
        {
          type: "paragraph",
          value: {
            html: [
              {
                type: "paragraph",
                children: [
                  {
                    text: payload.settings.caption || "",
                  },
                ],
              },
            ],
          },
        },
        {
          type: "name",
          value: payload.settings.nameLabel || "",
          required: false,
          requiredError: payload.settings.nameRequiredError || "",
        },
        {
          type: "email",
          value: payload.settings.emailLabel || "",
          required: true,
          requiredError: payload.settings.emailRequiredError || "",
          incorrectError: payload.settings.emailInvalidError || "",
        },
        {
          type: "subject",
          value: payload.settings.subjectLabel || "",
          required: false,
          requiredError: payload.settings.subjectRequiredError || "",
        },
        {
          type: "textarea",
          value: payload.settings.messageLabel || "",
          required: false,
          requiredError: payload.settings.messageRequiredError || "",
        },
        {
          type: "consent",
          mode: "disabled",
          value: {
            html: [
              {
                type: "paragraph",
                children: [
                  {
                    text: payload.settings.consentMessage || "",
                  },
                ],
              },
            ],
          },
          requiredError: payload.settings.consentRequiredError || "",
        },
        {
          type: "submit",
          value: payload.settings.sendLabel || "",
          wide: false,
          sendSuccessLabel: payload.settings.sendSuccessLabel || "",
          sendErrorLabel: payload.settings.sendErrorLabel || "",
        },
        {
          type: "options",
          sendErrorMessage: payload.settings.sendErrorMessage || "",
          confirmation: payload.settings.confirmation || "",
          poweredByFooter: true,
        },
      ],
    };
  }

  const {
    ID: id,
    teamID,
    name,
    licenseID,
    lcGroupIDs: livechatGroupIDs,
    version,
    updatedAt,
    settings: {
      header,
      caption,
      confirmation,
      nameLabel,
      emailLabel,
      subjectLabel,
      messageLabel,
      sendLoadingLabel,
      sendErrorMessage,
      namePlaceholder,
      emailPlaceholder,
      subjectPlaceholder,
      messagePlaceholder,
      sendLabel,
      sendSuccessLabel,
      sendErrorLabel,
      nameRequiredError,
      emailRequiredError,
      emailInvalidError,
      subjectRequiredError,
      messageRequiredError,
      consentRequiredError,
      consentMode,
      consentMessage,
      wordpressContactForm,
      fields,
    },
  } = payload;

  return trimObject({
    id,
    teamID,
    name,
    licenseID,
    header,
    caption,
    confirmation,
    nameLabel,
    emailLabel,
    subjectLabel,
    messageLabel,
    sendLoadingLabel,
    sendErrorMessage,
    namePlaceholder,
    emailPlaceholder,
    subjectPlaceholder,
    messagePlaceholder,
    sendLabel,
    sendSuccessLabel,
    sendErrorLabel,
    nameRequiredError,
    emailRequiredError,
    emailInvalidError,
    subjectRequiredError,
    messageRequiredError,
    consentRequiredError,
    consentMode,
    consentMessage,
    wordpressContactForm: !!wordpressContactForm,
    livechatGroupIDs: livechatGroupIDs.map(String),
    fields,
    version,
    updatedAt,
  });
}
